import { yupResolver } from '@hookform/resolvers/yup'
import React from 'react'
import { baseProductVS } from 'services/validations/catalog/baseProduct'
import StandardPricingInput from 'ui-shared/FormComponents/pricing/standard/StandardPricingInput'
import LinkedRulesPanel from 'ui-shared/LinkedRulesPanel'
import MainProductForm, { MainProductFormProps } from './MainProductForm'

export type BaseProductFormProps = MainProductFormProps

const BaseProductForm: React.FC<BaseProductFormProps> = (props) => {
  return (
    <MainProductForm {...props} resolver={yupResolver(baseProductVS)}>
      <StandardPricingInput hideFixedPrice />
      <LinkedRulesPanel />
    </MainProductForm>
  )
}

export default BaseProductForm
